<template>
	<div class="main">
		<header class="page-title">
			<h2>Languages</h2>
			<div class="ml-auto">
				<button @click="showCreateModal" class="btn btn-md btn-success" v-show="userRoles.includes('languages.update')">
					<i class="fas fa-plus"></i> New Language
				</button>
			</div>
		</header>
		<div class="table-responsive">
			<table class="comments">
				<thead>
					<tr>
						<th>Language</th>
						<th>Active</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="language in languages">
						<td v-if="language.isDefault"><strong class="help-cursor-on-hover">{{ language.name }}
							<i class="fas fa-check-circle icon-right" title="This is the default language"></i></strong>
						</td>
						<td v-else>{{ language.name }}</td>
						<td><span :class="language.statusClass" class="badge">{{ language.status }}</span></td>
						<td class="nowrap">
							<a @click="showEditModal(language)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('languages.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
							<a @click="deleteLanguage(language.id)" class="btn btn-icon btn-danger" href="#" title="Delete" v-show="userRoles.includes('languages.update')"><i class="fas fa-fw fa-trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<modal @close="closeCreateModal" v-show="isCreateModalVisible">
			<template slot="header">
				<h4 class="modal-title">New Language</h4>
			</template>
			<template slot="body">
				<div class="form-group select2-fixed">
					<label for="locale">Language</label>
					<vue-select
							:options="locales"
							id="locale"
							label="title"
							name="locale"
							reduce="locale => locale.title"
							v-model="selectedLocale"
					>
					</vue-select>
					<p class="input-error" v-if="errors.errors.title">{{ errors.errors.title }}</p>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeCreateModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveLanguage" class="btn btn-md btn-success" href="#"><i class="fas fa-check"></i> Add New Language</a>
			</template>
		</modal>

		<modal @close="closeEditModal" v-if="selectedLanguage" v-show="isEditModalVisible">
			<template slot="header">
				<h4 class="modal-title">Edit Language: {{ selectedLanguage.title }}</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label for="status">Status</label>
					<select :disabled="selectedLanguage.isDefault" id="status" v-model="selectedLanguage.status">
						<option :selected="selectedLanguage.status === 'active'" value="active">Active</option>
						<option :selected="selectedLanguage.status === 'hidden'" value="hidden">Hidden</option>
						<option :selected="selectedLanguage.status === 'disabled'" value="disabled">Disabled</option>
					</select>
				</div>
				<label class="label-checkbox mt-2" id="default">
					<input :disabled="selectedLanguage.status !== 'active'" type="checkbox" v-model="selectedLanguage.isDefault">
					<span>Make default language</span>
				</label>
			</template>
			<template slot="footer">
				<a @click="closeEditModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveLanguage" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import Errors from '../../Utils/Errors.js';
	import modal from '../Modal/DefaultModal.vue';
	import ISO6391 from 'iso-639-1';
	import VueSelect from '../../../../node_modules/vue-select';

	export default {
		components: {
			modal,
			VueSelect
		},
		props: {
			dataLanguages: {
				type: Array
			}
		},
		data() {
			return {
				languages: this.dataLanguages,

				selectedLocale: null,
				selectedLanguage: null,

				locales: [],
				isCreateModalVisible: false,
				isEditModalVisible: false,

				userRoles: this.$currentUserRoles,
				errors: new Errors(),
			}
		},
		created() {
			let localeCodes = ISO6391.getAllCodes();

			for (let i = 0; i < localeCodes.length; i++) {
				this.locales.push({
					locale: localeCodes[i],
					title: ISO6391.getName(localeCodes[i]),
					native_name: ISO6391.getNativeName(localeCodes[i])
				});
			}
		},
		methods: {
			saveLanguage: function () {
				let vm = this;

				if (vm.selectedLanguage) {
					axios.put('/api/' + vm.$selectedSite.slug + '/languages/' + vm.selectedLanguage.id, vm.selectedLanguage)
						.then(response => {
							this.$toastr.success('Language updated successfully.');
							window.location.reload();
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Save language failed.', 'Error');
						});
				} else {
					axios.post('/api/' + vm.$selectedSite.slug + '/languages', vm.selectedLocale)
						.then(response => {
							this.$toastr.success('New language saved.');
							window.location.reload();
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Save new language failed.', 'Error');
						});
				}
			},
			deleteLanguage: function (id) {
				let vm = this;
				vm.$dialog.confirm('Are you sure you want to delete this language?')
					.then((dialog) => {
						axios.delete('/api/' + vm.$selectedSite.slug + '/languages/' + id)
							.then(response => {
								location.reload();
								vm.$toastr.success('Delete successful.');
							})
							.catch(errors => {
								dialog.close();
								vm.$toastr.error('Delete failed.');
							});
					})
					.catch(error => {
						vm.$toastr.error('Delete aborted.');
					});
			},
			showCreateModal: function () {
				this.isCreateModalVisible = true;
			},
			closeCreateModal: function () {
				this.isCreateModalVisible = false;
			},
			showEditModal: function (language) {
				this.selectedLanguage = {
					id: language.id,
					title: language.title,
					status: language.status,
					isDefault: language.isDefault
				};
				this.isEditModalVisible = true;
			},
			closeEditModal: function () {
				this.isEditModalVisible = false;
			},
		}
	}
</script>
